exports.en = {
  TRANSPARENT_ACCOUNT: {
    SEARCH: {
      TITLE: 'Transparent accounts',
      PLACEHOLDER: 'Search by account name or account number',
      NO_RESULTS: 'No results found for the account name or account number entered',
      ERROR_BACKEND: 'We apologise, but the application is momentarily unavailable. Please contact us toll free on 800 207 207.'
    },
    ACCOUNTS_TABLE: {
      OWNER: 'Account holder',
      NUMBER: 'Account number'
    },
    RESULTS: {
      TITLE: 'Transparent account',
      BACK_TO_SEARCH: 'Back to search',
      NO_RESULTS: 'Transparent account was not found',
      ACCOUNT_NUMBER: 'Transparent account',
      ACCOUNT_OWNER: 'Transparent account holder',
      ACCOUNT_BALANCE: 'Total balance on current account',
      ACCOUNT_DESCRIPTION: 'Description',
      ACCOUNT_TRANSACTIONS: {
        TITLE: 'Movement on account',
        FROM: 'Transactions from',
        TO: 'Transactions to',
        SEARCH: 'Search',
        SEARCH_PLACEHOLDER: 'Name, description, variable code, constant code',
        FILTER_SET: 'Filter',
        FILTER_RESET: 'Reset filter'
      },
      CURRENCY: 'Currency',
      FOUND_COUNT: '%{smart_count} item found |||| %{smart_count} items found |||| %{smart_count} items found',
      VISIBLE_COUNT: '%{smart_count} item shown |||| %{smart_count} items shown |||| %{smart_count} items shown',
      HISTORY: {
        TITLE: 'Transaction history',
        DOWNLOAD_ERROR: 'You are not authorised to download the file.'
      }
    }
  },
  DATE: 'Date',
  TYPE: 'Type',
  ACCOUNT_NAME: 'Account name',
  ACCOUNT_NUMBER: 'Account number',
  DESCRIPTION: 'Note',
  AMOUNT: 'Amount',
  SHOW_MORE: 'Show more',
  VARIABLE_SYMBOL: 'Variable code',
  CONSTANT_SYMBOL: 'Constant code',
  SPECIFIC_SYMBOL: 'Specific symbol',
  CZK: 'CZK'
}
